module.exports = __webpack_public_path__ + "static/media/alert.efb12e48.mp3";